/**
 * Product Collection Vue component
 * ------------------------------------------------------------------------------
 * Main template in sections/index__featured-product-newest.liquid
 *
 * Collection products retrieved via Collections and Product Ajax API
 *
 */

import axios from 'axios'
import Cookies from 'js-cookie'

import VueTabs from '@/js/components/vue-tabs.vue'
import VueTab from '@/js/components/vue-tab.vue'
import ProductItem from '@/js/components/product-item.js'

import { storefrontRequestConfig, STOREFRONT_URL } from '@/js/utils/api'
import { productQuery, transformGraphqlProduct } from '@/js/utils/data'

export default {
  components: {
    VueTabs,
    VueTab,
    ProductItem
  },

  props: {
    collectionHandle: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isLoading: true,
      collectionProducts: []
    }
  },

  async created () {
    this.collectionProducts = await this._getCollectionProducts(this.collectionHandle)

    this.isLoading = false
  },

  methods: {
    _getCollectionProducts (collectionHandle, lastProducts = [], lastCursor = '') {
      const currentState = Cookies.get('state') || 'NSW' // used to filter products based on the available inventory in a location
      const data = `{
        collection(handle: "${collectionHandle}") {
          handle
          products(first: 250 ${lastCursor ? `, after: "${lastCursor}"` : ''}) {
            edges {
              node {
                ${productQuery}
              }
              cursor
            }
            pageInfo {
              hasNextPage
            }
          }
        }
      }`

      // eslint-disable-next-line no-undef
      return axios.post(STOREFRONT_URL, data, storefrontRequestConfig).then(({ data }) => {
        const products = data.data.collection.products.edges
        const filteredProducts = [...lastProducts]
        const hasNextPage = data.data.collection.products.pageInfo.hasNextPage
        const lastProductCursor = products[products.length - 1].cursor

        products.forEach((product) => {
          let productItem = {}
          productItem = transformGraphqlProduct(product.node)

          // check if the current state value is ACT
          if (currentState === 'ACT') {
            // If the state is ACT, include products from both ACT and NSW warehouses
            if (productItem && productItem.tags.includes('badge:just_listed') && (productItem.available_on?.includes(currentState) || productItem.available_on?.includes('NSW'))) {
              // set the formatted product
              filteredProducts.push(productItem)
            }
          } else {
            // check the state value (from the Cookie) and match if the selected state has an available inventory in the product
            if (productItem && productItem.tags.includes('badge:just_listed') && productItem.available_on?.includes(currentState)) {
              // set the formatted product
              filteredProducts.push(productItem)
            }
          }
        })

        // If there is next page AND there are not more than 8 products
        // Get next 250 products
        if (hasNextPage && filteredProducts.length < 8) {
          return this._getCollectionProducts(collectionHandle, filteredProducts, lastProductCursor)
        }

        return filteredProducts
      }).catch((error) => {
        console.log('Newest product section error:', error)
        throw error
      })
    }
  }
}
